/**
 * The copilot's publish outcome (botcircuits-agent-builder-copilot-native publish_tools.py): a
 * CUSTOM bot message `{type: 'CUSTOM', content: {kind: 'publish.result', status, text, ...}}`,
 * stored in the transcript like the onboarding cards.
 */

export const PUBLISH_CARD = 'publish.result';
const STATUSES = new Set(['published', 'review_requested', 'failed']);
const SNIPPET_PREFIX = '<script src="https://web-plugin.botcircuits.com/';

/** What the onboarding cards and the composer send to ask for these. */
export const TEST_REQUEST = 'Create automated test scenarios for my agent.';
export const PUBLISH_REQUEST = 'Publish my agent and show me how to add it to my website.';

/** Every channel's setup page, relative to /app/{appId}. */
export const CHANNELS = [
    { id: 'web', label: 'Website', path: '/channels/web/install' },
    { id: 'fb', label: 'Facebook Messenger', path: '/channels/fb' },
    { id: 'twilio', label: 'Twilio', path: '/channels/twilio' },
    { id: 'whatsapp', label: 'WhatsApp', path: '/channels/whatsapp' },
    { id: 'slack', label: 'Slack', path: '/channels/slack' },
];

const text = (value, limit) => (typeof value === 'string' ? value.trim().slice(0, limit) : '');

/** Validate a publish card from the network before rendering it. */
export function sanitizePublishCard(content) {
    if (!content || typeof content !== 'object' || content.kind !== PUBLISH_CARD || !STATUSES.has(content.status)) return null;
    const snippet = typeof content.snippet === 'string' && content.snippet.startsWith(SNIPPET_PREFIX)
        ? content.snippet.slice(0, 2000) : '';
    return {
        kind: PUBLISH_CARD,
        status: content.status,
        text: text(content.text, 1000),
        versionName: text(content.versionName, 100),
        keyId: text(content.keyId, 100),
        firstPublish: content.firstPublish === true,
        snippet: content.status === 'failed' ? '' : snippet,
    };
}
